import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { CreateLinkURLReq } from '@models/link-url.model';
import { LinkUrlService } from '@services/link-url.service';
import { map } from 'rxjs';

export const getLinkResolver: ResolveFn<CreateLinkURLReq | null> = (route) => {
    const id = route.paramMap.get('id');
    const router = inject(Router);
    const linkService = inject(LinkUrlService);

    if (!id) {
        console.error('No id provided');
        router.navigate(['/']);
        return null;
    }

    return linkService.getLinkById(id).pipe(
        map((res) => {
            if (res.ID !== 1) {
                return null;
            }

            return res.Data;
        })
    );
};
